<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item>合作商家管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <p class="red">“特别提醒：”其他用户成为你的合作商家后，即成为你在前端场景中定义的特殊身份用户，拥有一定的特殊功能权限，主要包括：分销推广、推广返利、批发采购、买手货架等功能权限。实际情况将根据你选择的前端版本呈现。</p>
      <el-tabs v-model="activeName" @tab-click="handleTab">
        <el-tab-pane label="合作商家管理" name="first">
          <el-table
            :data="tabListOne"
            height="52vh"
            style="width: 100%"
            @row-click="handleDetail"
          >
            <!-- <el-table-column prop="user.accountid" label="账户ID" width="180">
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="user.companyname" label="企业名称">
            </el-table-column>
            <el-table-column prop="user.sex" label="性别" width="80">
            </el-table-column>
            <el-table-column prop="user.age" label="年龄" width="80">
            </el-table-column>
            <!-- <el-table-column
              prop="user.mobile"
              :formatter="formatPhone"
              label="手机号"
              width="180"
            >
            </el-table-column> -->
            <!-- <el-table-column prop="user.attrname" label="用户属性" width="180">
            </el-table-column>
            <el-table-column prop="user.levelname" label="用户等级">
            </el-table-column> -->
            <el-table-column label="所在地区">
              <template slot-scope="scope">
                {{
                  scope.row.user.provincename ? scope.row.user.provincename : ""
                }}
                {{ scope.row.user.cityname ? scope.row.user.cityname : "" }}
                {{ scope.row.user.areaname ? scope.row.user.areaname : "" }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 start -->
          <div class="pagination_wrap flex-rowc">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next, jumper"
              :page-size="20"
              :total="listTotalOne"
            >
            </el-pagination>
          </div>
          <!-- 分页 end -->
        </el-tab-pane>
        <el-tab-pane name="second">
          <template #label>
            <span v-html="labelTwo"></span>
          </template>
          <el-table
            :data="tabListTwo"
            height="52vh"
            style="width: 100%"
            @row-click="handleDetail"
          >
            <!-- <el-table-column label="账户ID" width="180">
              <template slot-scope="scope">
                {{ scope.row.user.accountid }}<span class="badge_round"></span>
              </template>
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="user.companyname" label="企业名称">
            </el-table-column>
            <el-table-column prop="user.sex" label="性别" width="80">
            </el-table-column>
            <el-table-column prop="user.age" label="年龄" width="80">
            </el-table-column>
            <!-- <el-table-column prop="user.attrname" label="用户属性" width="180">
            </el-table-column>
            <el-table-column prop="user.levelname" label="用户等级">
            </el-table-column> -->
            <el-table-column label="所在地区">
              <template slot-scope="scope">
                {{
                  scope.row.user.provincename ? scope.row.user.provincename : ""
                }}
                {{ scope.row.user.cityname ? scope.row.user.cityname : "" }}
                {{ scope.row.user.areaname ? scope.row.user.areaname : "" }}
              </template>
            </el-table-column>
            <el-table-column label="申请时间">
              <template slot-scope="scope">
                {{ scope.row.askdate | formatDate }}
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 start -->
          <div class="pagination_wrap flex-rowc">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next, jumper"
              :page-size="20"
              :total="listTotalTwo"
            >
            </el-pagination>
          </div>
          <!-- 分页 end -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getCooperationQy } from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "companyUserList",
  data() {
    return {
      activeName: "first",
      tabListOne: [],
      listTotalOne: 0,
      labelTwo: "加入申请",
      tabListTwo: [],
      listTotalTwo: 0,
      params: {
        pageindex: 1,
        pagesize: 20,
        qyid: "",
        checkstate: 1,
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.params.qyid = qyid;
        this.getCooperationQy();
      } else {
        this.$router.back();
      }
    },

    // 手机号隐藏四位
    formatPhone(row) {
      const phone = row.mobile;
      let hiddenPhone = "";

      if (phone.length === 11) {
        hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      }

      return hiddenPhone;
    },

    // 动态添加标记
    renderHTML() {
      // `<span>加入申请</span>`+
      const newLabel = `<span>加入申请${
        this.tabListTwo.length > 0
          ? '<span class="badge">new</span></span>'
          : ""
      }`;
      this.labelTwo = newLabel;
    },

    handleTab(tab) {
      if (tab.index == 0) {
        this.params.checkstate = 1;
        this.getCooperationQy();
      } else if (tab.index == 1) {
        this.params.checkstate = 0;
        this.getCooperationQy();
      }
    },
    getCooperationQy() {
      let { params } = this;
      getCooperationQy(params).then((res) => {
        if (params.checkstate == 0) {
          this.tabListTwo = res.list;
          this.listTotalTwo = res.total;
        } else if (params.checkstate == 1) {
          console.log(res.total, "======");
          this.tabListOne = res.list;
          this.listTotalOne = res.total;
        }
      });
    },

    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getCooperationQy();
    },
    handleDetail(e) {
      // this.$router.push(`/companyIndex/companyUserDetail/${e.openid}/${e.id}`);
      this.encryptstringadd('companyUserDetail', {openid: e.openid, id: e.id})
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.userListPage {
  .main_container {
    margin: 20px auto;
  }
  /deep/ .el-tabs__item {
    position: relative;
    .badge {
      position: absolute;
      font-size: 12px;
      color: red;
      top: -8px;
    }
  }
  /deep/ .el-table .cell {
    position: relative;
    .badge_round {
      display: inline-block;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 3px;
    }
  }
  .red {
    color: red;
    font-size: 12px;
  }
}
</style>